export function canTransferUnionLeadership({
  viewerRole,
  memberRole,
  isSelf,
  guildMatches,
}) {
  return String(viewerRole || '') === 'leader'
    && String(memberRole || '') !== 'leader'
    && !Boolean(isSelf)
    && Boolean(guildMatches);
}

export function leadershipTransferConfirmation(nickname) {
  const targetName = String(nickname || '선택한 멤버').trim() || '선택한 멤버';
  return `${targetName}에게 주딱 권한을 넘길까요?\n\n현재 주딱은 파딱으로 전환되고, 유니온 소유 권한도 새 주딱에게 이전됩니다. 새 주딱이 다시 넘기기 전에는 되돌릴 수 없습니다.`;
}
